import { lazy } from "react";
import { Navigate } from "react-router";
import Loadable from "src/routes/Loadable";

const Ewallet = Loadable(
  lazy(() => import("src/pages/admin/financial/ewallet"))
);
const DepositWallet = Loadable(
  lazy(() => import("src/pages/admin/financial/deposit"))
);
const FundCredits = Loadable(
  lazy(() => import("src/pages/admin/financial/fundCredit/index"))
);
const Payout = Loadable(
  lazy(() => import("src/pages/admin/financial/payout/index"))
);
const BmcPayout = Loadable(
  lazy(() => import("src/pages/admin/financial/bmc-payout/index"))
);
const PayoutRequest = Loadable(
  lazy(() =>
    import("src/pages/admin/financial/payout/components/request/index")
  )
);
const PayoutHistory = Loadable(
  lazy(() =>
    import("src/pages/admin/financial/payout/components/history/index")
  )
);
const FinancialReport = Loadable(
  lazy(() =>
    import("src/pages/admin/financial/financialReport/financialReport")
  )
);

const LatestSales = Loadable(
  lazy(() => import("src/pages/admin/financial/sales/index"))
);

const BuyPackageWallet = Loadable(
  lazy(() => import("src/pages/admin/financial/buy-package/index"))
);

const MainWallet = Loadable(
  lazy(() => import("src/pages/admin/financial/main-wallet/index"))
);

const CommissionWallet = Loadable(
  lazy(() => import("src/pages/admin/financial/commission-wallet/index"))
);
const MiningWallet = Loadable(
  lazy(() => import("src/pages/admin/financial/mining-wallet/index"))
);
const APIDeFiWallet = Loadable(
  lazy(() => import("src/pages/admin/financial/api-deFi-wallet/index"))
);
// const BMCTokenWallet = Loadable(
//   lazy(() => import("src/pages/admin/financial/bmc-token-wallet/index"))
// );

const financial = [
  {
    path: "financial",
    children: [
      { element: <Navigate to="e-wallet" />, index: true },
      { path: "e-wallet", element: <Ewallet /> },
      { path: "deposit-wallet", element: <DepositWallet /> },
      { path: "fund-credits", element: <FundCredits /> },
      {
        path: "payout",
        element: <Payout />,
        children: [
          { index: true, element: <Navigate to="request" replace /> },
          { path: "request", element: <PayoutRequest /> },
          { path: "history", element: <PayoutHistory /> },
        ],
      },
      { path: "report", element: <FinancialReport /> },
      { path: "sales", element: <LatestSales /> },
      { path: "buy-package-wallet", element: <BuyPackageWallet /> },
      { path: "main-wallet", element: <MainWallet /> },
      { path: "commission-wallet", element: <CommissionWallet /> },
      { path: "mining-wallet", element: <MiningWallet /> },
      { path: "api-deFi-wallet", element: <APIDeFiWallet /> },
      // { path: "bmc-token-wallet", element: <BMCTokenWallet /> },
      { path: "bmc-payout", element: <BmcPayout /> },

    ],
  },
];

export default financial;
